import React from 'react'
import { object, string } from 'prop-types'
import styles from './EventSponsorLinkedArticles.module.scss'

export const EventSponsorLinkedArticles = ({ title, articles }) => {
  const hasArticles = !!articles.length
  return (
    <div className={styles.EventSponsorLinkedArticles}>
      <h2>{title || 'Latest:'}</h2>
      {hasArticles && (
        <ul>
          {articles.map(
            (article) =>
              article?.fullUrlPath && (
                <li key={article?.id}>
                  <a href={article.fullUrlPath}>{article?.headline}</a>
                  {article?.contentType && (
                    <span className={styles.EventSponsorLinkedArticlesTag}>
                      {article?.contentType}
                    </span>
                  )}
                </li>
              )
          )}
        </ul>
      )}
    </div>
  )
}

EventSponsorLinkedArticles.propTypes = {
  title: string,
  articles: object
}
